export var setStorage = function (key, data) {
    var storageKey = '__local_' + key;
    if (!data) {
        return;
    }
    if (localStorage) {
        try {
            localStorage.setItem(storageKey, JSON.stringify(data));
        }
        catch (e) {
            console.warn("failed to setItem to localStorage, key=" + storageKey, e);
        }
    }
};
export var getStorage = function (key) {
    var storageKey = '__local_' + key;
    if (localStorage) {
        try {
            var data = localStorage.getItem(storageKey);
            return data ? JSON.parse(data) : '';
        }
        catch (e) {
            console.warn("failed to getItem from localStorage, key=" + storageKey, e);
            return '';
        }
    }
    return '';
};
export var removeItem = function (key) {
    var storageKey = '__local_' + key;
    if (localStorage) {
        try {
            localStorage.removeItem(storageKey);
        }
        catch (e) {
            console.warn("failed to removeItem from localStorage, key=" + storageKey, e);
        }
    }
};
